/**
 * InstallPromptStrip — editorial hairline strip surfacing the PWA install
 * prompt. Per UX-AC-063 / AC-101.
 *
 * The strip is dismissable; dismissal persists to localStorage and the
 * `useInstallPrompt` hook ensures the strip never re-appears.
 */
import { Button } from './ui/Button';
import { useInstallPrompt } from '../lib/install';

export function InstallPromptStrip() {
  const prompt = useInstallPrompt();
  if (!prompt.available) return null;
  return (
    <aside
      role="region"
      aria-label="Install prompt"
      className="mb-10 border border-ink-200 bg-surface px-4 py-3 flex items-center justify-between gap-4"
    >
      <p className="font-serif italic text-sm text-ink-700 leading-snug">
        Add Connoisseur to your home screen.
      </p>
      <div className="flex items-center gap-3 shrink-0">
        <Button variant="ghost" size="sm" onClick={prompt.dismiss}>
          Not now
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            void prompt.install();
          }}
        >
          Install
        </Button>
      </div>
    </aside>
  );
}
